import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";
import Autocomplete from "@material-ui/lab/Autocomplete";
//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";

// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
	Select,
	InputLabel,
	// MenuItem,
	Modal,
	Backdrop,
	Fade,
	FormHelperText,
	NativeSelect,
	Button,
	Breadcrumbs,
	Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import { NavLink } from "react-router-dom";

//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	// paper: {
	// 	backgroundColor: theme.palette.background.paper,
	// 	border: "2px solid #000",
	// 	boxShadow: theme.shadows[5],
	// 	padding: theme.spacing(2, 4, 3),
	// },
}));

const ActivationCards = () => {
	const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [downloadFlag, setDownloadFlag] = useState(false);
	const [branchIdNo, setBranchIdNo] = useState(get_cookies('branchidno'));
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: addDays(new Date(), 7),
	});
	const classes = useStyles();

	//const [acType, setacType] = useState([]); //for data of type dropdown
    const [typeFilter, setTypeFilter] = useState('onprocess'); //for type dropdown

	// Data Fetching
	useEffect(() => {
		data();
	}, []);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	//add
	useEffect(() => {
	    if(posts.length > 0){
	        setDownloadFlag(true);
	    }
	}, [posts]);
	
	//search button
	const dataFilter = async () => {
        const result = await axios.get(
            process.env.REACT_APP_API_URL+'activation_cards_report', {
            params:{
				filter_type: typeFilter,
				hqidno: branchIdNo,
            }
        })
	console.log(result.data.data);
        setPosts(result.data.data);
    }

	const data = async () => {
		// const res = await axios.get(
		// 	//"https://www.breakingbadapi.com/api/characters"
		// // 	"http://localhost/jcphq_new/public/activation_cards_report?filter_type=onhand"
		// // );

		// `${baseUrl}/activation_cards_report`, {
		// 	params: {
		// 		filter_type: 'onhand',
		// 	}
		// })	

		//console.log(res.data);
		//console.log(res.data.data);
		setDataLoaded(true);
	};

	const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};

	const selectTypeProps = {
		options: ['On Hand', 'On Process'],
		// getOptionLabel: (option) => option.description + ' - ' + option.branchidno
		getOptionLabel:  (option) => option
	};

	const columns = [
		{
			name: "idno",
			label: "ID No.",
			options: {
				filter: false,
				// display: "excluded",
			},
		},
		{
			name: "trandate",
			label: "Request Date",
			// options: {
			// 	filter: false,
			// },
		},
		{
			name: "receiveddate",
			label: "Recieve Date",
			// options: {
			// 	filter: false,
			// },
		},
	];

	const options = {
		filter: false,
		// filterType: "dropdown",
		selectableRows: "none",
		filterType: "multiselect",
		responsive: "standard",
		setFilterChipProps: (colIndex, colName, data) => {
			//console.log(colIndex, colName, data);
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},   
		download: false,  //add this
		print: false,
		viewColumns: false, //add this
		// tableBodyHeight,
	};

    const style = {
		marginBottom: '1rem',
		marginTop:"2.5em",
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AssessmentTwoTone />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/reports">
						<h2 className="header-title">Reports</h2>
					</NavLink>
					<Typography color="textPrimary">Activation Cards Report</Typography>
				</Breadcrumbs>
			</div>
			<div className="page-container">
				<div style={style}>
					{/* <TextField
						id="outlined-basic"
						label="Select Date"
						variant="outlined"
						onFocus={() => setOpen(true)}
						autoComplete="off"
						value={`${format(
							dateRange.startDate,
							"MM/dd/yyyy"
						)} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
					/> */}
					{/* <DateRangePicker
						open={open}
						toggle={toggle}
						onChange={(range) => dateRangeHandler(range)}
					/> */}
					<Grid container spacing={2}>
						<Grid item xs={12} sm={4}>
								<Autocomplete
                                        {...selectTypeProps}
                                        autoComplete
                                        includeInputInList
										className={classes.autoComplete}
                                        renderInput={(params) => (
                                            <TextField
												{...params}
                                                margin="normal"
                                                label="Select Type"
												variant="outlined"
												required="true"
                                            />
										)}
										onChange={(event, newValue) => {
											if (!newValue == "" || !newValue == null){
												//prep_data.warehouse = JSON.stringify(newValue.id, null, ' ');
												//console.log(JSON.stringify(newValue.id, null, ' '));
												if(newValue === 'On Hand')
													setTypeFilter('onhand');
												else if(newValue === 'On Process'){
													setTypeFilter('onprocess');
												}
											}
										}}
                                    />
							{/* <NativeSelect
								value={typeFilter}
								onChange={e => setTypeFilter(e.target.value)}
								inputProps={{
									name: 'Type',
								}}>
								<option value=''>Choose Type</option>
								<option value="onprocess">On Process</option> 
								<option value="onhand">On Hand</option> 	  
							</NativeSelect> 
							<FormHelperText>Select Type</FormHelperText> */}
						</Grid>
						<Grid item xs={1}>
							<Button style ={{marginTop: "35px"}} variant="contained" color="primary" onClick={() => {dataFilter()}}>Search</Button>
						</Grid>
					</Grid>	

				</div>
				{!dataLoaded ? (
					<Preloader />
				) : (
					<MUIDataTable
						title={
							<div>
								<h3 className="header-title" style ={{color: "#339933"}}>
									Activation Cards Report
								</h3>
							</div>
						}
						data={posts}
						columns={columns}
						options={options}
					/>
				)}
			</div>
		</div>
	);
};

export default ActivationCards;
